import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import maskGroupBg from "assets/images/others/attendee-side-images/Maskgroup.png";
import profilePic from "assets/images/others/host-side-images/attende1.png";
import { ReactComponent as Star } from "assets/images/svgs/attendee/attende-star.svg";
import { ReactComponent as FavouriteChart } from "assets/images/svgs/attendee/attende-favorite-chart.svg";
import { ReactComponent as User } from "assets/images/svgs/attendee/attende-profile-2user.svg";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "components/breadcrumbs/AttendeeBreadcrumb";
import { siteRoutes } from "utils/helpers/enums/routes";
import Minors from "./component/Minors";
import DigitalPassport from "./component/DigitalPassport";
import useStore from "hooks/useStore";
import useAttendee from "../useHooks";
import { BAGDE_TYPES } from "utils/helpers/enums/shared.enum";
import {
  differenceInYears,
  differenceInMonths,
  differenceInDays,
} from "date-fns";
import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";

interface Tab {
  name: string;
  component: JSX.Element;
}

const FamilyMembers = () => {
  const navigate = useNavigate();
  const tabs: Tab[] = [
    { name: "Minors", component: <Minors /> },
    { name: "Digital Passport", component: <DigitalPassport /> },
    // { name: "My Experiences", component: <MyExperiences /> },
    // { name: "Favourite Hosts", component: <FavouriteHosts /> },
  ];
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const [data, setData] = useState<any>([]);

  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.attendeeHome },
    { title: "Family Members", path: siteRoutes.familyMembers },
  ];

  const { getMyBadges } = useAttendee();
  const { isProfileCompleted } = useStore();

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.attendeeHome, { replace: true });
    }
  }, [isProfileCompleted, navigate]);
  useEffect(() => {
    const payload = {
      badgeType: BAGDE_TYPES.ACHIEVEMENT,
    };
    getMyBadges(setData, payload);
  }, []);

  const {
    getUserFamilyName,
    getUserFullName,
    getTotalEvents,
    getTotalMembers,
    getUserProfilePic,
    getUserCity,
    getUserState,
    getUserAddress,
    getPastEventsCreatedAt,
  } = useStore();
  const userFamilyName = getUserFamilyName();
  const userFullName = getUserFullName();
  const totalEvents = getTotalEvents();
  const totalMembers = getTotalMembers();
  const profilePicMain = getUserProfilePic() || profilePic;
  const userCity = getUserCity();
  const userState = getUserState();
  const userAddress = getUserAddress();
  const pastEventsCreatedAt = getPastEventsCreatedAt();

  const now = new Date();
  const createdAt = new Date(pastEventsCreatedAt);
  const years = differenceInYears(now, createdAt);
  const months = differenceInMonths(now, createdAt);
  const days = differenceInDays(now, createdAt);
  let timeSince = "";
  if (years >= 1) {
    timeSince = `${years} year${years > 1 ? "s" : ""}`;
  } else if (months >= 1) {
    timeSince = `${months} month${months > 1 ? "s" : ""}`;
  } else {
    timeSince = `${days} day${days > 1 ? "s" : ""}`;
  }

  return (
    <div>
      <div
        style={{ backgroundImage: `url(${maskGroupBg})` }}
        className="bg-cover bg-center bg-no-repeat h-full lg:h-[250px] w-full"
      >
        <div className="h-full ">
          <div className="container">
            <AttendeeBreadcrumb links={breadcrumbLinks} />
            <div className="flex  flex-col gap-2">
              <h2 className="text-4xl text-primaryBlueText">
                Hello {userFullName}!
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className={`container ${data.length > 0 ? 'lg:mt-[-140px]' : 'lg:mt-[-95px]'}`}>
        <div className="flex justify-between flex-wrap lg:flex-row gap-4 lg:gap-0  items-center">
          <div className="flex flex-wrap items-center gap-2 sm:gap-4">
            <img
              className="w-36 h-36 object-cover border-4 border-white rounded-full"
              src={profilePicMain}
              alt="profilePic"
            />
            <div className="lg:mt-12">
              <span className="text-3xl text-blackie font-semibold mb-4">
                {userFamilyName} Family
              </span>
              {/* <p className="text-base text-primaryBlueText">
                <span className="text-blackie font-medium">Address:</span>
                <span className="text-sm text-blackie ms-1">{userAddress}</span>
              </p>
              <p className="text-base text-primaryBlueText">
                <span className="text-blackie font-medium">City:</span>
                <span className="text-sm text-blackie ms-1">{userCity}</span>
              </p>
              <p className="text-base text-primaryBlueText">
                <span className="text-blackie font-medium">State:</span>
                <span className="text-sm text-blackie ms-1">{userState}</span>
              </p> */}
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-4 sm:gap-2  flex-wrap bg-attendeBlueBg rounded-lg sm:rounded-full px-3 py-3">
              <span className="flex items-center text-base whitespace-nowrap text-primaryBlueText">
                <Star className="mr-1" /> {timeSince} Member
              </span>
              <span className="flex items-center text-base whitespace-nowrap text-primaryBlueText">
                <User className="mr-1" /> {totalMembers} Members
              </span>
              <span className="flex items-center whitespace-nowrap text-base text-primaryBlueText">
                <FavouriteChart className="mr-1" /> {totalEvents} Experiences
              </span>
            </div>
            {data.length > 0 && (
              <div className="flex flex-col items-center justify-center gap-2 rounded-lg w-[193px] h-[217px] bg-white p-3 shadow-md">
                <img
                  className="w-[126px] h-[126px]"
                  src={getFilePathWithBackendUrl(data[0].image.name)}
                  alt={data[0].name}
                />
                <span className="text-base text-blackie font-medium">
                  {data[0].name}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="mt-4 flex flex-wrap gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`px-4 py-2 rounded-lg font-medium transition-colors duration-300 ${
                activeTab.name === tab.name
                  ? "bg-tabsBlueBg text-white"
                  : "bg-fade text-labelTextColor"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="mt-4">{activeTab.component}</div>
      </div>
    </div>
  );
};

export default FamilyMembers;
